
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'Box',
  data() {
    return {
      styles: {
        'background-color': '#FAF0CA'
      }
    }
  }
});
